import React from 'react'
import { useGlobal } from '../../hooks/useGlobal'
import { buildFileUrl } from '../../config/strapi'

export function Footer() {
  const { data, loading, error } = useGlobal()

  if (loading || error || !data?.Footer) return null

  const { Logo, Adress, ImageLink = [], Button = [] } = data.Footer

  return (
    <footer
      style={{
        width: '100%',
        background: '#0081c6',
        color: '#fff',
        padding: 0,
        margin: 0,
        border: 'none',
        minHeight: 140,
        fontFamily: 'Poppins, Arial, sans-serif',
        fontSize: 15,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: 1200,
          margin: '0 auto',
          padding: '36px 40px',
          gap: 40,
          flexWrap: 'wrap',
        }}
      >
        {/* Grupo principal: logo + linha + textos */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            gap: 28,
            flex: '1 1 640px',
            minWidth: 280,
          }}
        >
          {/* Logo */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            {Logo?.logo?.url && (
              <a href={Logo.link} target="_blank" rel="noopener noreferrer">
                <img
                  src={buildFileUrl(Logo.logo.url)}
                  alt="Paraná Governo do Estado"
                  style={{
                    width: 140,
                    height: 'auto',
                    display: 'block',
                  }}
                />
              </a>
            )}
            {Logo?.text_logo && (
              <a
                href="https://www.sedest.pr.gov.br/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: 11,
                  color: '#e0e0e0',
                  marginTop: 6,
                  lineHeight: 1.2,
                  textAlign: 'center',
                  textDecoration: 'underline',
                  fontWeight: 500,
                }}
              >
                {Logo.text_logo}
              </a>
            )}
          </div>

          {/* Divisor vertical */}
          <div
            aria-hidden="true"
            style={{
              width: 2,
              alignSelf: 'stretch',
              minHeight: 96,
              backgroundColor: '#fff',
              flexShrink: 0,
              borderRadius: 1,
            }}
          />

          {/* Endereço e horários */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'flex-start',
              color: '#fff',
              textAlign: 'left',
              minWidth: 0,
            }}
          >
            <strong style={{ color: '#fff', fontWeight: 700 }}>
              {Adress?.title}
            </strong>
            {Adress?.adress && (
              <span style={{ marginTop: 4 }}>{Adress.adress}</span>
            )}
            <div
              style={{
                marginTop: 8,
                fontSize: 13,
                color: '#fff',
                fontWeight: 600,
                lineHeight: 1.4,
              }}
            >
              Confira os nossos{' '}
              <a
                href="http://www.iat.pr.gov.br/Pagina/Enderecos-Sede-e-Diretorias"
                style={{ color: '#b3e0ff', textDecoration: 'underline', fontWeight: 600 }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Endereços em Curitiba
              </a>{' '}
              e os endereços dos{' '}
              <a
                href="http://www.iat.pr.gov.br/Pagina/Escritorios-Regionais"
                style={{ color: '#b3e0ff', textDecoration: 'underline', fontWeight: 600 }}
                target="_blank"
                rel="noopener noreferrer"
              >
                Escritórios Regionais
              </a>
              .
            </div>
            {Adress?.text && (
              <div
                style={{
                  marginTop: 8,
                  fontSize: 14,
                  color: '#e0e0e0',
                  lineHeight: 1.45,
                }}
              >
                {Adress.text.split('\n').map((line: string, i: number) => (
                  <React.Fragment key={i}>
                    {line}
                    <br />
                  </React.Fragment>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Redes e Celepar à direita */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 18,
            flexShrink: 0,
            marginLeft: 'auto',
          }}
        >
          {Button.map((btn: any, idx: number) => (
            <a
              key={idx}
              href={btn.link}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={btn.icon}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {btn.icon === 'FaFacebookF' && (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.691v-3.622h3.129V8.413c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.622h-3.12V24h6.116C23.406 24 24 23.408 24 22.674V1.326C24 .592 23.406 0 22.675 0"/>
                </svg>
              )}
            </a>
          ))}
          {ImageLink.map((img: any, idx: number) =>
            img.image?.url ? (
              <a
                key={idx}
                href={img.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <img
                  src={buildFileUrl(img.image.url)}
                  alt="Celepar"
                  style={{ height: 23, width: 'auto', display: 'block' }}
                />
              </a>
            ) : null
          )}
        </div>
      </div>
    </footer>
  )
}
